module.exports = __webpack_public_path__ + "static/logo-black-974ee3b577120efd62200f1c4770017a.png";